import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiroCards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"giro-cards"} maskId="square-filled-radius-0-stroke-1-IconGiroCards"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H18V8H22V20H6V16H2V4ZM7 16V19H21V9H18V16H7ZM5 8H8V9H5V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGiroCards;
